<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      title="批量设置运费明细"
      :in-dialog="inDialog"
      id-key="SupportId"
      :data="data"
      :form-rules="rules"
      :save-func="() => {}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row :gutter="10" v-if="Condition == '2'">
          <el-col :span="12">
            <el-form-item label="首件数量" prop="FirstQuantity">
              <el-input
                v-model="data.FirstQuantity"
                @blur="onBlur(data, 'FirstQuantity')"
                @focus="onFocus(data, 'FirstQuantity')"
                placeholder="请输入首件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件数量" prop="AfterQuantity">
              <el-input
                v-model="data.AfterQuantity"
                @blur="onBlur(data, 'AfterQuantity')"
                @focus="onFocus(data, 'AfterQuantity')"
                placeholder="请输入继件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="Condition == '1'">
          <el-col :span="12">
            <el-form-item label="首件重量" prop="FirstWeight">
              <el-input
                v-model="data.FirstWeight"
                @blur="onBlur(data, 'FirstWeight')"
                @focus="onFocus(data, 'FirstWeight')"
                placeholder="请输入首件重量"
              >
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件重量" prop="AfterWeight">
              <el-input
                v-model="data.AfterWeight"
                @blur="onBlur(data, 'AfterWeight')"
                @focus="onFocus(data, 'AfterWeight')"
                placeholder="请输入继件重量"
              >
                <template slot="append">kg</template></el-input
              >
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="金额范围" class="is-required">
              <el-row>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="FirstAmount">
                    <el-input size="mini" v-model="data.FirstAmount" @blur="onBlur(data,'FirstAmount')" @focus="onFocus(data,'FirstAmount')" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="line-height:28px;font-size:18px;text-align:center;">~</el-col>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="AfterAmount">
                    <el-input size="mini" v-model="data.AfterAmount" @blur="onBlur(data,'AfterAmount')" @focus="onFocus(data,'AfterAmount')" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运费" prop="AmountFreight">
              <el-input v-model="data.AmountFreight" @blur="onBlur(data,'AmountFreight')" @focus="onFocus(data,'AmountFreight')" placeholder="请输入运费"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    Condition: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      data: {
        FreightId: null,
        ProvinceId: null, //省
        ProvinceName: "",
        CityId: null, //市
        CityName: "",
        DistrictId: null, //区
        AreaName: "",
        FirstQuantity: 0, //异地：首件；本地：范围
        FirstFreight: 0, //异地：首件运费；本地：运费
        AfterQuantity: 0, //异地：继件；本地：范围
        AfterFreight: 0, //异地：继件运费
        FirstWeight: 0, //金额范围
        AfterWeight: 0, //金额范围
        AmountFreight: 0, //金额范围内运费
      },
      Supports: [],
      api: require("@/api/sale/freightSupport").default,
      rules: {
        FirstQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        FirstFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        AfterFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        FirstWeight: [
          { required: true, message: "重量范围不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterWeight: [
          { required: true, message: "重量范围不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AmountFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    setData(data) {
      this.Supports = data.map((x) => {
        return { ...x };
      });
    },
    onBeforeSave() {
      if (this.Supports.length == 0) {
        this.$message.warning("请添加城市");
        return false;
      }
      if (this.Condition == "2") {
        this.Supports.forEach((x) => {
          x.FirstQuantity =
            this.Condition == 2 ? this.data.FirstQuantity : x.FirstQuantity; //异地：首件；本地：范围
          x.FirstFreight =
            this.Condition == 2 ? this.data.FirstFreight : x.FirstFreight; //异地：首件运费；本地：运费
          x.AfterQuantity =
            this.Condition == 2 ? this.data.AfterQuantity : x.AfterQuantity; //异地：继件；本地：范围
          x.AfterFreight =
            this.Condition == 2 ? this.data.AfterFreight : x.AfterFreight; //异地：继件运费
          x.T = x.T == 0 ? 0 : 1;
        });
      } else if (this.Condition == "1") {
        this.Supports.forEach((x) => {
          x.FirstFreight =
            this.Condition == 1 ? this.data.FirstFreight : x.FirstFreight; //异地：首件运费；本地：运费
          x.AfterFreight =
            this.Condition == 1 ? this.data.AfterFreight : x.AfterFreight; //异地：继件运费
          x.FirstWeight =
            this.Condition == 1 ? this.data.FirstWeight : x.FirstWeight; //金额范围
          x.AfterWeight =
            this.Condition == 1 ? this.data.AfterWeight : x.AfterWeight; //金额范围
          x.T = x.T == 0 ? 0 : 1;
        });
      }

      this.$emit("detail-save", this.Supports);
      this.close(true);
      return false;
    },
    onClosed() {
      this.Supports = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.citys-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
.citys-box {
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .item {
    line-height: 40px;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    padding-left: 10px;
    cursor: default;
    .close-btn {
      float: right;
      line-height: 40px;
      margin-right: 13px;
      color: #7b7b7b;
    }
  }
  .item:hover {
    background-color: #eefff9;
  }
}
</style>